// messageInfo：メッセージの開閉機能

export default function messageInfo() {
  var $messageCont = $('.js-messageCont');

  if(!($messageCont[0])) return;

  // カード高さの調整
  cardHeight()

  // カード押下時
  $messageCont.find('li .js-messageCard').on('click', function(event) {
    event.preventDefault();
    /* Act on the event */
    var $self = $(this).parents('li');

    // 同じメッセージが押下されたら
    if($self.hasClass('is-open')) {
      messageClose();
      return;
    }

    var $beforeItem = $('.js-messageCont').children('.is-open');
    var thisLeft = $self.offset().left;
    var $thisMessageInfo = $self.find('.js-messageInfoCont');
    var delayTime = 0;

    // 同じ行の処理のみdelayTimeを設定
    if ($beforeItem.length && $beforeItem.offset().top === $self.offset().top) {
      delayTime = 150;
    }

    // ビデオの停止
    stopVideo();

    // openクラスの付与
    $messageCont.find('li').removeClass('is-open');
    $self.addClass('is-open');

    // pos調整
    $thisMessageInfo.css('left', - thisLeft);
    $(window).resize(function() {
        thisLeft = $self.offset().left;
        $thisMessageInfo.css('left', - thisLeft);
    });

    // 開閉処理
    setTimeout(function() {
      $messageCont.children('li').not('.is-open').find('.js-messageInfoCont').slideUp(300);
    }, delayTime);
    $thisMessageInfo.slideDown(300);
  });

  // 閉じるボタン押下時
  $('.js-messageClose').on('click', function(event) {
    event.preventDefault();
    event.stopPropagation();
    /* Act on the event */
    messageClose();
  });

  // 閉じる挙動
  function messageClose() {
    stopVideo();
    $messageCont.find('li').removeClass('is-open');
    $messageCont.find('.js-messageInfoCont').slideUp(300);
  }

  // ビデオの停止
  function stopVideo() {
    var $target = $messageCont.find('.is-open iframe');
    if(!($target[0])) return;
    $target[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
  }

  // カード高さの調整
  function cardHeight() {
    var $messageCard = $messageCont.find('.js-messageCard');
    if(!($messageCard[0])) return;

    var maxH = 0;
    for (var i = 0; i < $messageCard.length; i++) {
      var thisH = $messageCard.eq(i).height();
      if (maxH < thisH) maxH = thisH;
    }
    $messageCard.height(maxH);
  }

}


// WEBPACK FOOTER //
// ./js/module/messageInfo.js